import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/newOrder.vue'
createPage(Page)